import React from 'react'

const Manual_inventario_receta_modificadores = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          Inventario - Receta a Opciones de Modificadores
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Esta guía explica cómo gestionar las recetas a los modificafores para optimizar el inventario. Permite un control preciso de los ingredientes y garantiza la consistencia en la preparación. Su consulta facilita realizar modificaciones de manera rápida y eficaz.
        </p>
        <iframe
          src="https://scribehow.com/embed/Inventario__Receta_a_Opciones_de_Modificadores__tIAr8p7xQdGQ_X8jryTuhw?as=scrollable"
          className="scribe-iframe-general-40"
          width="100%"
          height="4100"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_inventario_receta_modificadores